SP.lang.Class.define("SP.sitekit.form.validator.RegEx", {

	_options: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value) {
		var expression = new RegExp(this._options.pattern);
		return value === null || value === "" || expression.test(value);
	},

	getMessage: function () {
		return this._options.messages.regExMissmatch;
	}

});
